import { render, staticRenderFns } from "./SearchTextField.vue?vue&type=template&id=521cb585&"
import script from "./SearchTextField.vue?vue&type=script&lang=ts&"
export * from "./SearchTextField.vue?vue&type=script&lang=ts&"
import style0 from "./SearchTextField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports